export const mobilePayment = {
  mobilePaymentBank: "Banco",
  mobilePaymentPhone: "Teléfono",
  mobilePaymentAction: "Acción",
  mobilePaymentEdit: "Editar",
  mobilePaymentDelete: "Eliminar",
  mobilePaymentDeleteConfirm: "¿Estás seguro de borrar la cuenta de pago móvil?",
  mobilePaymentDeleteYes: "Sí",
  mobilePaymentDeleteNo: "No",

  mobilePaymentTitle: "Pago móvil",
  mobilePaymentAdd: "Añadir pago móvil",
  mobilePaymentBtnAdd: "Agregar",
  mobilePaymentBtnBack: "Volver",

  mobilePaymentEditTitle: "Editar pago móvil",

  mobilePaymentModalBank: "Banco",
  mobilePaymentModalPhone: "Teléfono",
  mobilePaymentModalSelectBank: "Selecciona un banco",
  mobilePaymentModalSelectBankMessage: "Por favor, selecciona un banco",
  mobilePaymentModalPhonePlaceholder: "Teléfono",
  mobilePaymentModalPhonePlaceholderMessage: "Por favor, ingresa tu número de teléfono",

  mobilePaymentModalSubmitBtn: "Aceptar",
  // New registration modal translations
  pagoMovilRegistrationTitle: "Registro de Pago Móvil Requerido",
  pagoMovilRegistrationMessage:
    "Para realizar depósitos o retiros con Pago Móvil, necesitas registrar tu cédula y número de teléfono.",
  pagoMovilRegistrationCedula: "Cédula de Identidad",
  pagoMovilRegistrationCedulaPlaceholder: "Ingresa su número de cédula",
  pagoMovilRegistrationCedulaMessage: "Por favor, ingresa tu cédula de identidad",
  pagoMovilRegistrationCedulaValidation: "Solo se permiten números",
  pagoMovilRegistrationCedulaMinLength: "La cédula debe tener al menos 7 dígitos",
  pagoMovilRegistrationCedulaMaxLength: "La cédula no puede tener más de 15 dígitos",
  pagoMovilRegistrationPhoneNumber: "Número de Teléfono",
  pagoMovilRegistrationPhoneNumberPlaceholder: "Ingresa su número de teléfono",
  pagoMovilRegistrationPhoneNumberMessage: "Por favor, ingresa tu número de teléfono",
  pagoMovilRegistrationPhoneValidation: "Por favor ingresa un número de teléfono válido",
  pagoMovilRegistrationPhoneMinLength: "El número de teléfono debe tener al menos 10 dígitos",
  pagoMovilRegistrationSubmitBtn: "Registrar",
  pagoMovilRegistrationCancelBtn: "Cancelar",
  pagoMovilRegistrationSuccessTitle: "Datos registrados correctamente",
  pagoMovilRegistrationSuccessMessage: "Su cédula y número de teléfono han sido registrados exitosamente.",
  pagoMovilRegistrationErrorTitle: "Error al registrar datos",
  pagoMovilRegistrationErrorMessage:
    "Hubo un error al intentar registrar su información. Por favor, inténtelo nuevamente.",

  // AddPagoMovil form translations
  addPagoMovilExplanationTitle: "Registro de Información Personal Requerido",
  addPagoMovilExplanationMessage:
    "Para agregar una cuenta de Pago Móvil, necesitamos que registres tu información personal (nombre, apellido, cédula y teléfono). Esta información es requerida para procesar depósitos y retiros de forma segura.",
  registerAndAddPagoMovil: "Registrar y Agregar Pago Móvil",

  // Basic field names
  name: "Nombre",
  lastName: "Apellido",
  nationalID: "Cédula",
  phoneNumber: "Número de Teléfono",
  nameRequired: "El nombre es requerido",
  lastNameRequired: "El apellido es requerido",
  nationalIDRequired: "La cédula es requerida",
  phoneNumberRequired: "El número de teléfono es requerido",
  phoneNumberMinLength: "El número de teléfono debe tener al menos 10 dígitos",
  phoneNumberMaxLength: "El número de teléfono no puede tener más de 11 dígitos",

  // Confirmation overlay translations
  confirmSaveChanges: "¿Estás seguro de que quieres guardar los cambios?",
  accept: "Aceptar",
  cancel: "Cancelar",

  // Delete confirmation modal translations
  deleteConfirmationTitle: "Eliminar cuenta de pago móvil",
  deleteConfirmationMessage: "Estas a punto de eliminar una de tus cuentas de pago móvil",
  deleteConfirmationBank: "Banco",
  deleteConfirmationPhone: "Teléfono",

  // Email verification translations
  registrationEmailVerificationTitle: "Verificación de Correo Electrónico",
  registrationEmailVerificationMessage:
    "Se ha enviado un enlace de verificación a tu correo electrónico. Por favor, revisa tu bandeja de entrada y haz clic en el enlace para continuar.",
};
